"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateResubmitAction = exports.validateRejectApproval = exports.validateSubmitForApproval = exports.validateApprovalConfig = exports.ResubmitActionSchema = exports.RejectApprovalSchema = exports.SubmitForApprovalSchema = exports.ApprovalConfigSchema = void 0;
const yup = __importStar(require("yup"));
/** PUT /companies/:companyId/approval-config */
exports.ApprovalConfigSchema = yup.object().shape({
    issue_units: yup.boolean(),
    transfer_units: yup.boolean(),
    update_unit_price: yup.boolean(),
    send_announcement: yup.boolean(),
});
/**
 * POST /companies/:companyId/actions/:actionType/submit-for-approval
 *
 * `companyId` and `actionType` are URL path parameters, not body fields.
 * The request body IS the action-specific payload (e.g. `{ newPrice, effectiveDate }` for
 * `update_unit_price`); there is no `payload` wrapper. Action-field validation happens in
 * the action-type service layer; this schema only asserts the body is a plain object.
 */
exports.SubmitForApprovalSchema = yup.object();
/** POST /approvals/:requestId/reject */
exports.RejectApprovalSchema = yup.object().shape({
    reason: yup.string().trim().min(1, "Rejection reason cannot be empty").required("reason is required"),
});
/**
 * POST /companies/:companyId/actions/:actionType/:actionRef/resubmit
 *
 * `companyId`, `actionType`, and `actionRef` are URL path parameters.
 * The request body IS the revised action-specific payload directly; there is no
 * `payload` wrapper. Action-field validation happens in the action-type service layer.
 */
exports.ResubmitActionSchema = yup.object();
const validateApprovalConfig = async (data) => {
    await exports.ApprovalConfigSchema.validate(data, { abortEarly: false });
};
exports.validateApprovalConfig = validateApprovalConfig;
const validateSubmitForApproval = async (data) => {
    await exports.SubmitForApprovalSchema.validate(data, { abortEarly: false });
};
exports.validateSubmitForApproval = validateSubmitForApproval;
const validateRejectApproval = async (data) => {
    await exports.RejectApprovalSchema.validate(data, { abortEarly: false });
};
exports.validateRejectApproval = validateRejectApproval;
const validateResubmitAction = async (data) => {
    await exports.ResubmitActionSchema.validate(data, { abortEarly: false });
};
exports.validateResubmitAction = validateResubmitAction;
//# sourceMappingURL=approval.js.map